const SearchIcon = ({ stroke='#272727' }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 0.999999 9 1C13.4183 1 17 4.58172 17 9Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.0004 19.0004L14.6504 14.6504" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default SearchIcon;